module.exports = {
    "longPressMessage": `Premere a lungo o premere Alt + Freccia gi\xf9 per aprire il menu`
};


//# sourceMappingURL=it-IT.main.js.map
